import React, { useRef, useState } from 'react';
import { Grid } from '@material-ui/core';
import Slider from 'react-slick';
import DefaultContainer from '../DefaultContainer';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import CaseCard from '../../templates/CaseCard';
import DefaultLink from '../../typeface/DefaultLink';
import Icon from '../Icon';
import styles from './style.module.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import cases from '../../data/casesThumb';

const moreString = 'More projects';

const CasesSliderSection = () => {
  const sliderRef = useRef(null);
  const [sliderCount, setSliderCount] = useState(1);
  const [disableButtons, setDisableButtons] = useState(false);
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    draggable: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerPadding: 0,
    afterChange: () => setDisableButtons(false),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const goLeft = () => {
    if (!disableButtons) {
      sliderRef.current.slickPrev();
      if (sliderCount - 1 > 0) {
        setSliderCount(sliderCount - 1);
      }
      setDisableButtons(true);
    }
  };

  const goRight = () => {
    if (!disableButtons) {
      sliderRef.current.slickNext();
      if (sliderCount < cases.length) {
        setSliderCount(sliderCount + 1);
      }
      setDisableButtons(true);
    }
  };

  return (
    <div className={styles.container}>
      <DefaultContainer direction="column">
        <Grid item>
          <HeadlineSmall>Cases</HeadlineSmall>
        </Grid>
        <Grid item>
          <HeadlineLarge
            className={styles.headlineLarge}
            stroke="work"
            medium
          >
          Recent
          </HeadlineLarge>
        </Grid>
      </DefaultContainer>
      <DefaultContainer
        direction="column"
        className={styles.containerSlider}
        noPadding
      >
        <Grid item>
          <div className={styles.slider}>
            <Slider
              {...settings}
              ref={sliderRef}
            >
              {
                cases.map(item => (
                  <CaseCard
                    key={item.path}
                    color={item.color}
                    caseBg={item.casebg}
                    caseImg={item.case}
                    caseImgLeftAlign={item.caseImgLeftAlign}
                    caseImgRightAlign={item.caseImgRightAlign}
                    title={item.title}
                    titleSmall={item.headline}
                    description={item.description}
                    path={item.path}
                    isWeb={item.isWeb}
                    isAndroid={item.isAndroid}
                    textColor={item.textColor}
                  />
                ))
            }
            </Slider>
          </div>
        </Grid>
      </DefaultContainer>
      <DefaultContainer
        direction="column"
        className={styles.containerStepper}
      >
        <Grid
          container
          direction="column"
          alignItems="flex-end"
          className={styles.containerInnerBottom}
        >
          <Grid item>
            <Grid container alignItems="center">
              <div
                onClick={goLeft}
                role="button"
                tabIndex={0}
                className={styles.angleLeftButton}
              >
                <Icon type="angleLeft" />
              </div>
              <h4 className={styles.indexTitle}>{`${sliderCount} / ${cases.length}`}</h4>
              <div
                onClick={goRight}
                role="button"
                tabIndex={0}
                className={styles.angleRightButton}
              >
                <Icon type="angleRight" />
              </div>
            </Grid>
          </Grid>
          <Grid item>
            <DefaultLink to="/cases" className={styles.link}>
              <p>{moreString}</p>
            </DefaultLink>
          </Grid>
        </Grid>
      </DefaultContainer>
    </div>
  );
};

export default CasesSliderSection;
